// Estado dos filtros da listagem (inspection.md §6.2 / quality-test §3.3) e a
// tradução desse estado para os query params de Y=3.

import type { InspectionListParams } from "../api/inspection";

export interface InspectionFilterValues {
  inspectionCode: string;
  responsibleName: string;
  dateFrom: string;
  dateTo: string;
  inspectionStatus: string;
  creationOrigin: string;
  hasAnomalies: string;
}

export const EMPTY_INSPECTION_FILTERS: InspectionFilterValues = {
  inspectionCode: "",
  responsibleName: "",
  dateFrom: "",
  dateTo: "",
  inspectionStatus: "",
  creationOrigin: "",
  hasAnomalies: "",
};

export const hasInspectionFilters = (filters: InspectionFilterValues) =>
  Object.values(filters).some((value) => value !== "");

/** Filtro vazio é omitido da query — nunca vira `?creationOrigin=`. */
export const toInspectionListParams = (
  filters: InspectionFilterValues,
): Partial<InspectionListParams> => ({
  inspectionCode: filters.inspectionCode || undefined,
  responsibleName: filters.responsibleName || undefined,
  dateFrom: filters.dateFrom || undefined,
  dateTo: filters.dateTo || undefined,
  inspectionStatus:
    (filters.inspectionStatus as InspectionListParams["inspectionStatus"]) ||
    undefined,
  creationOrigin:
    (filters.creationOrigin as InspectionListParams["creationOrigin"]) ||
    undefined,
  hasAnomalies:
    (filters.hasAnomalies as InspectionListParams["hasAnomalies"]) || undefined,
});
